import { render } from "./VehicleSelectorCompact.vue?vue&type=template&id=e3f3ed24&scoped=true"
import script from "./VehicleSelectorCompact.vue?vue&type=script&lang=js"
export * from "./VehicleSelectorCompact.vue?vue&type=script&lang=js"

import "./VehicleSelectorCompact.vue?vue&type=style&index=0&id=e3f3ed24&lang=scss&scoped=true"

import exportComponent from "/opt/vr23-npm/htdocs/templates/vr23/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3f3ed24"]])

export default __exports__